import { createServiceAction } from '../util/actionHelper.js';

export const getUserProfileAct = createServiceAction(
  'getUserProfile',
  'requested'
);
